import React, { useState } from "react";
import httpClient from "../utils/httpClients";
import { useNavigate, Link } from "react-router-dom";
import TopTost from "../utils/topTost";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { isValidPhoneNumber } from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input/core";

function Signup() {
  const [formData, setFormData] = useState({
    isd: "+91",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    agreeTerms: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "firstName":
        if (!value.trim()) error = "First name is required";
        else if (!/^[a-zA-Z]+$/.test(value))
          error =
            "First name should contain only letters (no spaces or special characters)";
        else if (value.length > 10)
          error = "First name should not exceed 10 characters";
        break;
      // case "lastName":
      //   if (!value.trim()) error = "Last name is required";
      //   else if (!/^[a-zA-Z]+$/.test(value))
      //     error =
      //       "Last name should contain only letters (no spaces or special characters)";
      //   else if (value.length > 10)
      //     error = "Last name should not exceed 10 characters";
      //   break;
      case "email":
        if (!value) error = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          error = "Please enter a valid email address";
        break;
      case "phone":
        // We store national number in `phone` and calling code in `isd`.
        // Validate the full E.164 number: `${isd}${phone}`.
        const fullPhone =
          typeof value === "string" && value.startsWith("+")
            ? value
            : `${formData.isd || ""}${value || ""}`;

        if (!fullPhone || fullPhone === "+") {
          error = "Phone number is required";
        } else if (!isValidPhoneNumber(fullPhone)) {
          error = "Please enter a valid phone number";
        } else {
          // Additional validation for minimum length
          const digitsOnly = fullPhone.replace(/\D/g, "");
          if (digitsOnly.length < 10) {
            error = "Phone number is too short";
          } else if (digitsOnly.length > 15) {
            error = "Phone number is too long";
          }
        }
        break;
      case "password":
        if (!value) error = "Password is required";
        else if (value.length < 8 || value.length > 16)
          error =
            "Password must be between 8 and 16 characters. It must contain at least one lowercase letter, one uppercase letter, a number and a special character";
        else if (!/[a-z]/.test(value))
          error =
            "Password must be between 8 and 16 characters. It must contain at least one lowercase letter, one uppercase letter, a number and a special character";
        else if (!/[A-Z]/.test(value))
          error =
            "Password must be between 8 and 16 characters. It must contain at least one lowercase letter, one uppercase letter, a number and a special character";
        else if (!/[0-9]/.test(value))
          error =
            "Password must be between 8 and 16 characters. It must contain at least one lowercase letter, one uppercase letter, a number and a special character";
        else if (!/[^\w\s]/.test(value))
          error =
            "Password must be between 8 and 16 characters. It must contain at least one lowercase letter, one uppercase letter, a number and a special character";
        break;
      case "confirmPassword":
        if (!value) error = "Please confirm your password";
        else if (value !== formData.password) error = "Passwords do not match";
        break;
      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let processedValue = value;
    if (name === "firstName" || name === "lastName") {
      processedValue = value.replace(/\s/g, "");
      if (processedValue.length > 10) {
        processedValue = processedValue.slice(0, 10);
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : processedValue,
    }));

    if (name !== "agreeTerms") {
      const error = validateField(name, processedValue);
      setErrors((prev) => ({
        ...prev,
        [name]: error,
      }));
    }
  };

  // Phone number change handler
  const handlePhoneChange = (value) => {
    console.log("val phone change", value);
    const full = value || "";
    let isd = formData.isd || "";
    let phone = "";

    if (full) {
      try {
        const parsed = parsePhoneNumber(full);
        if (parsed) {
          isd = `+${parsed.countryCallingCode}`;
          phone = String(parsed.nationalNumber || "");
        }
      } catch (e) {
        // Fallback parsing for E.164: +<cc><national>
        const m = full.match(/^\+(\d{1,3})(\d+)$/);
        if (m) {
          isd = `+${m[1]}`;
          phone = m[2];
        }
      }
    }

    setFormData((prev) => ({
      ...prev,
      isd,
      phone,
    }));

    const error = validateField("phone", phone);
    setErrors((prev) => ({
      ...prev,
      phone: error,
    }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // Phone input blur handler
  const handlePhoneBlur = () => {
    const error = validateField("phone", formData.phone);
    setErrors((prev) => ({
      ...prev,
      phone: error,
    }));
  };

  const handleKeyPress = (e) => {
    if (
      (e.target.name === "firstName" ||
        e.target.name === "lastName" ||
        e.target.name === "email") &&
      e.key === " "
    ) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "agreeTerms") {
        const error = validateField(key, formData[key]);
        if (error) newErrors[key] = error;
      }
    });

    if (!formData.agreeTerms) {
      newErrors.agreeTerms = "Please agree to the terms of use";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      //   TopTost.fire({
      //     icon: "error",
      //     title: "Please fix the errors in the form",
      //   });
      return;
    }

    setIsLoading(true);

    try {
      // Send the complete validated phone number to backend
      const userData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        isd: formData.isd,
        phoneNumber: formData.phone,
        email: formData.email,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        userType: "User",
      };

      console.log("Sending user data:", userData); // For debugging

      const res = await httpClient.post("common/auth/signup", userData);

      // if (res.data?.success) {
      //   toast.success(res.data.message, {
      //     autoClose: 3000,
      //     position: "top-right",
      //   });
      // }
      if (res.data?.data?.token) {
        localStorage.setItem("volumeAuthToken", res.data.data.token);
      }

      navigate("/verify-otp", {
        state: { email: formData.email, type: "s" },
        replace: true,
      });
    } catch (err) {
      console.error("Signup error:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
      });
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Signup failed. Please try again.";

      // TopTost.fire({
      //   icon: "error",
      //   title: errorMessage,
      // });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <style>
        {`
          .phone-input {
            display: flex;
            align-items: center;
            min-height: 38px;
            border: 1px solid #d8dbe0;
            border-radius: 0.375rem;
            background: #fff;
            padding: 0 0.65rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          }

          .phone-input:focus-within {
            border-color: #86b7fe;
            box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
          }

          .phone-input.is-invalid {
            border-color: #dc3545;
          }

          .phone-input.is-valid {
            border-color: #198754;
          }

          .phone-input .PhoneInputCountry {
            margin-right: 0.5rem;
          }

          .phone-input .PhoneInputCountrySelectArrow {
            opacity: 0.6;
          }

          .phone-input .PhoneInputInput {
            flex: 1;
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
            background: transparent !important;
            color: inherit;
            padding: 0.45rem 0;
            min-width: 0;
          }
        `}
      </style>
      <section className="login-content overflow-hidden">
        <div className="row no-gutters align-items-center bg-white">
          <div className="col-md-12 col-lg-6 align-self-center">
            <Link
              to="/"
              className="navbar-brand d-flex align-items-center  pt-5 mb-3 justify-content-center text-primary"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                alt="Logo"
              />{" "}
            </Link>
            <div className="row justify-content-center pt-5 px-4">
              <div className="col-md-9">
                <div className="card d-flex justify-content-center mb-0  iq-auth-form">
                  <div className="card-body">
                    <h2 className="mb-2 text-center">Sign Up</h2>
                    <p className="text-center">Create your Muzik account.</p>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="firstName" className="form-label">
                              First Name{" "}
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                errors.firstName ? "is-invalid" : ""
                              }`}
                              id="firstName"
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              onKeyPress={handleKeyPress}
                              placeholder="John"
                              maxLength="10"
                              // required
                            />
                            {errors.firstName && (
                              <div className="invalid-feedback">
                                {errors.firstName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="lastName" className="form-label">
                              Last Name{" "}
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                errors.lastName ? "is-invalid" : ""
                              }`}
                              id="lastName"
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              onKeyPress={handleKeyPress}
                              placeholder="Doe"
                              maxLength="10"
                              // required
                            />
                            {errors.lastName && (
                              <div className="invalid-feedback">
                                {errors.lastName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="email" className="form-label">
                              Email
                            </label>
                            <input
                              type="email"
                              className={`form-control ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              onKeyPress={handleKeyPress}
                              placeholder="xyz@example.com"
                              // required
                            />
                            {errors.email && (
                              <div className="invalid-feedback">
                                {errors.email}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="phone" className="form-label">
                              Phone No.
                            </label>
                            {/* <PhoneInput
                              international
                              countryCallingCodeEditable={false}
                              defaultCountry="IN"
                              value={formData.phone}
                              onChange={handlePhoneChange}
                              onBlur={handlePhoneBlur}
                              className={`phone-input ${errors.phone ? 'is-invalid' : ''}`}
                              inputProps={{
                                className: `form-control ${errors.phone ? 'is-invalid' : ''}`,
                                id: "phone",
                                name: "phone",
                                required: true
                              }}
                            />
                            {errors.phone ? (
                              <div className="invalid-feedback d-block">
                                {errors.phone}
                              </div>
                            ) : (
                              <small className="text-muted">
                                Enter your complete phone number with country code
                              </small>
                            )} */}
                            <PhoneInput
                              international
                              countryCallingCodeEditable={false}
                              defaultCountry="IN"
                              value={
                                formData.isd && formData.phone
                                  ? `${formData.isd}${formData.phone}`
                                  : undefined
                              }
                              onChange={handlePhoneChange}
                              onBlur={handlePhoneBlur}
                              className={`phone-input ${
                                errors.phone
                                  ? "is-invalid"
                                  : formData.phone &&
                                      isValidPhoneNumber(
                                        `${formData.isd || ""}${formData.phone}`,
                                      )
                                    ? "is-valid"
                                    : ""
                              }`}
                              inputProps={{
                                className: `form-control ${
                                  errors.phone
                                    ? "is-invalid"
                                    : formData.phone &&
                                        isValidPhoneNumber(
                                          `${formData.isd || ""}${formData.phone}`,
                                        )
                                      ? "is-valid"
                                      : ""
                                }`,
                                id: "phone",
                                name: "phone",
                                required: true,
                              }}
                            />

                            {errors.phone ? (
                              <div className="invalid-feedback d-block">
                                {errors.phone}
                              </div>
                            ) : formData.phone &&
                              isValidPhoneNumber(
                                `${formData.isd || ""}${formData.phone}`,
                              ) ? (
                              <div className="valid-feedback d-block">
                                ✅ Phone number looks good!
                              </div>
                            ) : (
                              <small className="text-muted">
                                Enter your complete phone number with country
                                code
                              </small>
                            )}
                          </div>
                        </div>
                        {/* Rest of the form remains same */}
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="password" className="form-label">
                              Password
                            </label>
                            <div className="input-group">
                              <input
                                type={showPassword ? "text" : "password"}
                                className={`form-control ${
                                  errors.password ? "is-invalid" : ""
                                }`}
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="••••••"
                                minLength="6"
                                // required
                              />
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                <i
                                  className={`fa ${
                                    showPassword ? "fa-eye" : "fa-eye-slash"
                                  }`}
                                ></i>
                              </button>
                              {errors.password && (
                                <div className="invalid-feedback d-block">
                                  {errors.password}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label
                              htmlFor="confirmPassword"
                              className="form-label"
                            >
                              Confirm Password
                            </label>
                            <div className="input-group">
                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                className={`form-control ${
                                  errors.confirmPassword ? "is-invalid" : ""
                                }`}
                                id="confirmPassword"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="••••••"
                                minLength="6"
                                // required
                              />
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() =>
                                  setShowConfirmPassword(!showConfirmPassword)
                                }
                              >
                                <i
                                  className={`fa ${
                                    showConfirmPassword
                                      ? "fa-eye"
                                      : "fa-eye-slash"
                                  }`}
                                ></i>
                              </button>
                              {errors.confirmPassword && (
                                <div className="invalid-feedback d-block">
                                  {errors.confirmPassword}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 d-flex justify-content-center">
                          <div className="form-check mb-3">
                            <input
                              type="checkbox"
                              className={`form-check-input ${
                                errors.agreeTerms ? "is-invalid" : ""
                              }`}
                              id="agreeTerms"
                              name="agreeTerms"
                              checked={formData.agreeTerms}
                              onChange={handleChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="agreeTerms"
                              style={{
                                color: errors.agreeTerms ? "#dc3545" : "",
                              }}
                            >
                              I agree with the terms of use
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Signing Up...
                            </>
                          ) : (
                            "Sign Up"
                          )}
                        </button>
                      </div>
                      <p className="mt-3 text-center">
                        Already have an Account{" "}
                        <Link to="/login" className="text-underline">
                          Sign In
                        </Link>
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-lg-block d-none bg-primary p-0 overflow-hidden">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/auth/01.jpg`}
              className="img-fluid gradient-main"
              alt="login background"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Signup;
